
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { GpsTrackerDto } from '../../../backend/backendapi';
import TabGeneral from './TabGeneral';
import TabButton from '../../../util/TabButton';
import TabTrigger from './TabTrigger';

@Component({
  name: 'Tabs',
  components: {
    TabButton,
    TabTrigger,
    TabGeneral,
  },
})
export default class Tabs extends Vue {
  @Prop({ required: true })
  tracker!: GpsTrackerDto;
  @Prop({ default: false })
  disabled!: boolean;

  selectedTab: 'general' | 'trigger' = 'general';
}
